import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'unit';

export const unitActions = createTypes([
    'savePdfUnit',
    'saveVideoUnit',
    'saveQuizUnit',
    'setSeenUnitFlag'
], namespace);

export const unitActionCreators = {
    savePdfUnit: fromType(unitActions.savePdfUnit, ['pdfDetail', 'id']),
    saveVideoUnit: fromType(unitActions.saveVideoUnit, ['videoDetail', 'id']),
    saveQuizUnit: fromType(unitActions.saveQuizUnit, ['quiz', 'id']),
    setSeenUnitFlag: fromType(unitActions.setSeenUnitFlag, ['unitId', 'isSeen']),
}